import * as SDK from '@replai-platform/sdk';
import { QueryFunction, useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import * as provider from '../../api/provider';

const getTagsVideoAssets = async (requestParams: SDK.GetTagsVideoAssetsRequest) => {
  const res = await provider.getJson<object, SDK.GetTagsVideoAssetsResponse>(
    `${SDK.BASE_URL()}/tags/video_assets?${SDK.convertRequestToQueryParams(requestParams)}`
  );
  return res;
};

const KEY = 'tags-assets-with-metrics';
type Key = typeof KEY;

type Result = SDK.GetTagsVideoAssetsResponse;
type QueryKey = [Key, SDK.GetTagsVideoAssetsRequest];

type QueryOptions<R = Result> = UseQueryOptions<Result, unknown, R, QueryKey>;
type QueryResult<R = Result> = UseQueryResult<R>;

const queryFn: QueryFunction<Result, QueryKey> = ({ queryKey: [, requestParams] }) => getTagsVideoAssets(requestParams);

// This is exported so we can use useQueries
export function getTagsVideoAssetsQueryOptions<R = Result>(
  requestParams: SDK.GetTagsVideoAssetsRequest,
  options?: QueryOptions<R>
): QueryOptions<R> {
  return {
    queryKey: [KEY, requestParams],
    queryFn,
    ...options,
  };
}

export default function useTagsVideoAssets<R = Result>(
  requestParams: SDK.GetTagsVideoAssetsRequest,
  options?: QueryOptions<R>
): QueryResult<R> {
  return useQuery(getTagsVideoAssetsQueryOptions(requestParams, options));
}
